export const SECTIONS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'orders', label: 'Orders' },
  { key: 'workReviews', label: 'Work Reviews' },
  { key: 'workers', label: 'Workers' },
  { key: 'cemeteries', label: 'Cities & Cemeteries' },
  { key: 'packages', label: 'Packages' },
  { key: 'flowers', label: 'Flowers' },
  { key: 'promoCodes', label: 'Promo Codes' },
  { key: 'users', label: 'New Users' },
  { key: 'communications', label: 'Messages' },
  { key: 'support', label: 'Support' },
  { key: 'finance', label: 'Finance' },
  { key: 'adminAccess', label: 'Admin access' },
];

export const SUPER_ADMIN_EMAILS = [
  'aykhan@ayistgroup.com',
  'nishihimanshi@gmail.com',   // project Owner
  'admin@qabrtemiz.az',
];

export function normalizeAdmin(user) {
  if (!user) return null;
  const email = (user.email || '').toLowerCase();
  const isSuperAdmin = user.isSuperAdmin || user.role === 'super_admin' || SUPER_ADMIN_EMAILS.includes(email);
  return {
    ...user,
    email,
    role: isSuperAdmin ? 'super_admin' : (user.role || 'manager'),
    isSuperAdmin,
    access: isSuperAdmin
      ? Object.fromEntries(SECTIONS.map(s => [s.key, true]))
      : (user.access || {}),
    cityScope: user.cityScope || 'all',
    hideMoney: !isSuperAdmin || user.hideMoney === true,
  };
}

export function canAccess(user, section) {
  const admin = normalizeAdmin(user);
  if (!admin) return false;
  if (admin.isSuperAdmin) return true;
  return admin.access?.[section] === true;
}

export function canSeeMoney(user) {
  const admin = normalizeAdmin(user);
  return !!admin?.isSuperAdmin && admin.hideMoney !== true;
}

export function isOrderInScope(user, order) {
  const admin = normalizeAdmin(user);
  if (!admin || admin.isSuperAdmin || admin.cityScope === 'all') return true;
  const city = (
    order.city ||
    order.cityName ||
    order.graveLocation?.city ||
    order.cemeteryCity ||
    ''
  ).toString().toLowerCase();
  return city === admin.cityScope.toString().toLowerCase();
}

export function AccessDenied({ title = 'Access restricted' }) {
  return (
    <div className="p-8">
      <div className="bg-white border border-gray-100 rounded-2xl p-8 text-center shadow-sm">
        <div className="text-4xl mb-3">🔒</div>
        <h1 className="text-xl font-bold text-gray-900">{title}</h1>
        <p className="text-sm text-gray-500 mt-2">
          Your admin account does not have permission to view this section.
        </p>
      </div>
    </div>
  );
}
